import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "../../../models/common";

import { IAccountSettings } from "../../../models/AddOns/Accounting/AccountSettings/IAccountSettings";
import http from "../../../common/http-commons";

export const AccountSettingsService = {
  getLoginAccount: async (
    AccountSettingsPageName: string,
    clientId: string,
  ): Promise<IAccountSettings | IServerError | IResponse | null | any> => {
    if (!AccountSettingsPageName) return null;
    if (!clientId) return null;
    try {
      const response: AxiosResponse<IAccountSettings> =
        await http.get<IAccountSettings>(
          `/v1/${
            AccountSettingsPageName === "net_suite"
              ? "net-suite"
              : AccountSettingsPageName === "zoho_books"
                ? "zoho-books"
                : AccountSettingsPageName === "quick_books"
                  ? "quick-books"
                  : AccountSettingsPageName
          }/login?company_id=${clientId}`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  getAccountSettingsById: async (
    AccountSettingsPageName: string,
    clientId: string,
    navigateToLogout: (path: string) => void,
  ): Promise<IAccountSettings | IServerError | IResponse | null | any> => {
    if (!AccountSettingsPageName) return null;
    if (!clientId) return null;
    try {
      const response: AxiosResponse<IAccountSettings> =
        await http.get<IAccountSettings>(
          `/v1/add-ones-account-settings/${clientId}/?add_ones_type=${
            AccountSettingsPageName === "net_suite"
              ? "net-suite"
              : AccountSettingsPageName === "zoho_books"
                ? "zoho-books"
                : AccountSettingsPageName === "quick_books"
                  ? "quick-books"
                  : AccountSettingsPageName
          }`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IAccountSettings | IServerError | IResponse | any> => {
    const screenTag = requestPayload.accountSettingsPageName;

    try {
      const response: AxiosResponse<IAccountSettings> =
        await http.post<IAccountSettings>(
          `/v1/add-ones-account-settings/`,
          requestPayload,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delAccountSettings: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    const screenTag = delPayload.accountSettingsPageName;
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/${
          screenTag === "net_suite"
            ? "net-suite"
            : screenTag === "zoho_books"
              ? "zoho-books"
              : screenTag === "quick_books"
                ? "quick-books"
                : screenTag
        }-account-settings/${delPayload.clientId}/`,
      );

      if (response.status === 204) {
        return "Account Settings has been deleted successfully";
      } else if (response.status === 200) {
        return "Account Settings has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getAccountSettingsDDL: async (
    AccountSettingsPageName: string,
    clientId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!AccountSettingsPageName) return null;
    if (!clientId) return null;
    try {
      const response: AxiosResponse<any[]> = await http.get<any[]>(
        `/v1/${
          AccountSettingsPageName === "net_suite"
            ? "net-suite"
            : AccountSettingsPageName === "zoho_books"
              ? "zoho-books"
              : AccountSettingsPageName === "quick_books"
                ? "quick-books"
                : AccountSettingsPageName
        }/accounts?company_id=${clientId}`,
      );
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response;
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch {}
    // return {
    // 	expenseaccounts: [
    // 		{
    // 			label: "Cost of Goods Sold",
    // 			value: "310",
    // 		},
    // 		{
    // 			label: "Advertising",
    // 			value: "400",
    // 		},
    // 		{
    // 			label: "Bank Fees",
    // 			value: "404",
    // 		},
    // 		{
    // 			label: "Cleaning",
    // 			value: "408",
    // 		},
    // 		{
    // 			label: "Consulting & Accounting",
    // 			value: "412",
    // 		},
    // 		{
    // 			label: "Depreciation",
    // 			value: "416",
    // 		},
    // 		{
    // 			label: "Entertainment",
    // 			value: "420",
    // 		},
    // 		{
    // 			label: "Freight & Courier",
    // 			value: "425",
    // 		},
    // 		{
    // 			label: "General Expenses",
    // 			value: "429",
    // 		},
    // 		{
    // 			label: "Insurance",
    // 			value: "433",
    // 		},
    // 		{
    // 			label: "Interest Expense",
    // 			value: "437",
    // 		},
    // 		{
    // 			label: "Legal expenses",
    // 			value: "441",
    // 		},
    // 		{
    // 			label: "Light, Power, Heating",
    // 			value: "445",
    // 		},
    // 		{
    // 			label: "Motor Vehicle Expenses",
    // 			value: "449",
    // 		},
    // 		{
    // 			label: "Office Expenses",
    // 			value: "453",
    // 		},
    // 		{
    // 			label: "Printing & Stationery",
    // 			value: "461",
    // 		},
    // 		{
    // 			label: "Rent",
    // 			value: "469",
    // 		},
    // 		{
    // 			label: "Repairs and Maintenance",
    // 			value: "473",
    // 		},
    // 		{
    // 			label: "Wages and Salaries",
    // 			value: "477",
    // 		},
    // 		{
    // 			label: "Superannuation",
    // 			value: "478",
    // 		},
    // 		{
    // 			label: "Subscriptions",
    // 			value: "485",
    // 		},
    // 		{
    // 			label: "Telephone & Internet",
    // 			value: "489",
    // 		},
    // 		{
    // 			label: "Travel - National",
    // 			value: "493",
    // 		},
    // 		{
    // 			label: "Travel - International",
    // 			value: "494",
    // 		},
    // 		{
    // 			label: "Bank Revaluations",
    // 			value: "497",
    // 		},
    // 		{
    // 			label: "Unrealised Currency Gains",
    // 			value: "498",
    // 		},
    // 		{
    // 			label: "Realised Currency Gains",
    // 			value: "499",
    // 		},
    // 		{
    // 			label: "Income Tax Expense",
    // 			value: "505",
    // 		},
    // 	],
    // 	liabilityaccounts: [
    // 		{
    // 			label: "Accounts Payable",
    // 			value: "800",
    // 		},
    // 		{
    // 			label: "Unpaid Expense Claims",
    // 			value: "801",
    // 		},
    // 		{
    // 			label: "Wages Payable",
    // 			value: "803",
    // 		},
    // 		{
    // 			label: "Sales Tax",
    // 			value: "820",
    // 		},
    // 		{
    // 			label: "Employee Tax Payable",
    // 			value: "825",
    // 		},
    // 		{
    // 			label: "Superannuation Payable",
    // 			value: "826",
    // 		},
    // 		{
    // 			label: "Income Tax Payable",
    // 			value: "830",
    // 		},
    // 		{
    // 			label: "Historical Adjustment",
    // 			value: "840",
    // 		},
    // 		{
    // 			label: "Suspense",
    // 			value: "850",
    // 		},
    // 		{
    // 			label: "Rounding",
    // 			value: "860",
    // 		},
    // 		{
    // 			label: "Tracking Transfers",
    // 			value: "877",
    // 		},
    // 		{
    // 			label: "Owner A Drawings",
    // 			value: "880",
    // 		},
    // 		{
    // 			label: "Owner A Funds Introduced",
    // 			value: "881",
    // 		},
    // 	],
    // 	allaccounts: {
    // 		REVENUE: [
    // 			{
    // 				label: "Sales",
    // 				value: "200",
    // 			},
    // 			{
    // 				label: "Other Revenue",
    // 				value: "260",
    // 			},
    // 			{
    // 				label: "Interest Income",
    // 				value: "270",
    // 			},
    // 		],
    // 		DIRECTCOSTS: [
    // 			{
    // 				label: "Cost of Goods Sold",
    // 				value: "310",
    // 			},
    // 		],
    // 		EXPENSE: [
    // 			{
    // 				label: "Advertising",
    // 				value: "400",
    // 			},
    // 			{
    // 				label: "Bank Fees",
    // 				value: "404",
    // 			},
    // 			{
    // 				label: "Cleaning",
    // 				value: "408",
    // 			},
    // 			{
    // 				label: "Consulting & Accounting",
    // 				value: "412",
    // 			},
    // 			{
    // 				label: "Depreciation",
    // 				value: "416",
    // 			},
    // 			{
    // 				label: "Entertainment",
    // 				value: "420",
    // 			},
    // 			{
    // 				label: "Freight & Courier",
    // 				value: "425",
    // 			},
    // 			{
    // 				label: "General Expenses",
    // 				value: "429",
    // 			},
    // 			{
    // 				label: "Insurance",
    // 				value: "433",
    // 			},
    // 			{
    // 				label: "Interest Expense",
    // 				value: "437",
    // 			},
    // 			{
    // 				label: "Legal expenses",
    // 				value: "441",
    // 			},
    // 			{
    // 				label: "Light, Power, Heating",
    // 				value: "445",
    // 			},
    // 			{
    // 				label: "Motor Vehicle Expenses",
    // 				value: "449",
    // 			},
    // 			{
    // 				label: "Office Expenses",
    // 				value: "453",
    // 			},
    // 			{
    // 				label: "Printing & Stationery",
    // 				value: "461",
    // 			},
    // 			{
    // 				label: "Rent",
    // 				value: "469",
    // 			},
    // 			{
    // 				label: "Repairs and Maintenance",
    // 				value: "473",
    // 			},
    // 			{
    // 				label: "Wages and Salaries",
    // 				value: "477",
    // 			},
    // 			{
    // 				label: "Superannuation",
    // 				value: "478",
    // 			},
    // 			{
    // 				label: "Subscriptions",
    // 				value: "485",
    // 			},
    // 			{
    // 				label: "Telephone & Internet",
    // 				value: "489",
    // 			},
    // 			{
    // 				label: "Travel - National",
    // 				value: "493",
    // 			},
    // 			{
    // 				label: "Travel - International",
    // 				value: "494",
    // 			},
    // 			{
    // 				label: "Bank Revaluations",
    // 				value: "497",
    // 			},
    // 			{
    // 				label: "Unrealised Currency Gains",
    // 				value: "498",
    // 			},
    // 			{
    // 				label: "Realised Currency Gains",
    // 				value: "499",
    // 			},
    // 			{
    // 				label: "Income Tax Expense",
    // 				value: "505",
    // 			},
    // 		],
    // 		CURRENT: [
    // 			{
    // 				label: "Accounts Receivable",
    // 				value: "610",
    // 			},
    // 			{
    // 				label: "Prepayments",
    // 				value: "620",
    // 			},
    // 		],
    // 		INVENTORY: [
    // 			{
    // 				label: "Inventory",
    // 				value: "630",
    // 			},
    // 		],
    // 		FIXED: [
    // 			{
    // 				label: "Office Equipment",
    // 				value: "710",
    // 			},
    // 			{
    // 				label: "Less Accumulated Depreciation on Office Equipment",
    // 				value: "711",
    // 			},
    // 			{
    // 				label: "Computer Equipment",
    // 				value: "720",
    // 			},
    // 			{
    // 				label: "Less Accumulated Depreciation on Computer Equipment",
    // 				value: "721",
    // 			},
    // 		],
    // 		CURRLIAB: [
    // 			{
    // 				label: "Accounts Payable",
    // 				value: "800",
    // 			},
    // 			{
    // 				label: "Unpaid Expense Claims",
    // 				value: "801",
    // 			},
    // 			{
    // 				label: "Wages Payable",
    // 				value: "803",
    // 			},
    // 			{
    // 				label: "Sales Tax",
    // 				value: "820",
    // 			},
    // 			{
    // 				label: "Employee Tax Payable",
    // 				value: "825",
    // 			},
    // 			{
    // 				label: "Superannuation Payable",
    // 				value: "826",
    // 			},
    // 			{
    // 				label: "Income Tax Payable",
    // 				value: "830",
    // 			},
    // 			{
    // 				label: "Historical Adjustment",
    // 				value: "840",
    // 			},
    // 			{
    // 				label: "Suspense",
    // 				value: "850",
    // 			},
    // 			{
    // 				label: "Rounding",
    // 				value: "860",
    // 			},
    // 			{
    // 				label: "Tracking Transfers",
    // 				value: "877",
    // 			},
    // 			{
    // 				label: "Owner A Drawings",
    // 				value: "880",
    // 			},
    // 			{
    // 				label: "Owner A Funds Introduced",
    // 				value: "881",
    // 			},
    // 		],
    // 		TERMLIAB: [
    // 			{
    // 				label: "Loan",
    // 				value: "900",
    // 			},
    // 		],
    // 		EQUITY: [
    // 			{
    // 				label: "Retained Earnings",
    // 				value: "960",
    // 			},
    // 			{
    // 				label: "Owner A Share Capital",
    // 				value: "970",
    // 			},
    // 		],
    // 	},
    // };
  },
};
